function offTopSet() {
    var navDiff = 200;
    var pcNav = [];

    var sections = document.querySelectorAll('[id^="peth-floor"]');
    var li_len = sections.length;
    var li_last = li_len - 1;

    sections.forEach(function (section, index) {
        pcNav[index] = section.offsetTop - navDiff;
    });

    window.onscroll = function () {
        var nowTop = window.scrollY;
        var activeSet = false;

        document.querySelectorAll('#pcNav li').forEach(function (item, index) {
            item.classList.remove('active');
            var targetId = 'peth-floor' + (index + 1);
            var section = document.getElementById(targetId);

            if (section) {
                var sectionTop = section.offsetTop - navDiff;
                var sectionBottom = sectionTop + section.offsetHeight;

                if (nowTop >= sectionTop && nowTop < sectionBottom) {
                    item.classList.add('active');
                    activeSet = true;

                    document.getElementById('peth_up').setAttribute('href', '#' + (index > 0 ? 'peth-floor' + index : 'peth-floor1'));
                    document.getElementById('peth_down').setAttribute('href', '#' + 'peth-floor' + (index + 2 <= li_last + 1 ? index + 2 : 1));
                }
            }
        });

        if (!activeSet && nowTop < pcNav[0]) {
            document.getElementById('peth_up').setAttribute('href', '#peth-floor1');
            document.getElementById('peth_down').setAttribute('href', '#peth-floor2');
            document.querySelectorAll('#pcNav li')[0].classList.add('active');
        }
    };
}

document.addEventListener('DOMContentLoaded', function () {
    offTopSet();
    window.addEventListener('resize', offTopSet);

    document.querySelectorAll('.peth_nav a.qbtn, .peth_nav a.btn_el').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();

            var targetId = this.getAttribute('href').replace('#', '');
            var scrollTarget = document.getElementById(targetId);
            var scrollPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 80;

            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });
        });
    });

    document.querySelectorAll('.qbtn').forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault(); 
            var defaultImg = button.querySelector('.default-img');
            var overImg = button.querySelector('.over-img');

            defaultImg.style.display = 'none';
            overImg.style.display = 'block';

            setTimeout(function() {
                defaultImg.style.display = 'block';
                overImg.style.display = 'none';
            }, 500);
        });
    });
});